module.exports = __webpack_public_path__ + "src/assets/img/product-laka-3.2104e3ea.png";